import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
  AddressElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { Button, Form } from "react-bootstrap";
import ReactCountryDropdown from "react-country-dropdown";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PROMISE);

function CheckoutForm({ deliveryDetails, clientSecret, setErrors }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  // const validateDeliveryDetails = (data) => {
  //   const errors = {};

  //   if (!data.firstName.trim()) {
  //     errors.firstName = "First name is required";
  //   }

  //   if (!data.lastName.trim()) {
  //     errors.lastName = "Last name is required";
  //   }

  //   if (!data.email.trim()) {
  //     errors.email = "Email is required";
  //   } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
  //     errors.email = "Invalid email format";
  //   }

  //   if (!data.countryCode.trim()) {
  //     errors.countryCode = "Country code required";
  //   } else if (!/^\+\d+$/.test(data.countryCode)) {
  //     errors.countryCode = "Must start with + and contain digits";
  //   }

  //   if (!data.phone.trim()) {
  //     errors.phone = "Phone number required";
  //   } else if (!/^\d{6,15}$/.test(data.phone)) {
  //     errors.phone = "Invalid phone number";
  //   }

  //   if (!data.address.trim()) {
  //     errors.address = "Address required";
  //   }

  //   if (!data.city.trim()) {
  //     errors.city = "City required";
  //   }

  //   if (!data.state.trim()) {
  //     errors.state = "State required";
  //   }

  //   if (!data.zip.trim()) {
  //     errors.zip = "ZIP required";
  //   }

  //   return errors;
  // };

  // Just updates order details on order and loads payment-suceess page to confirm
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + "/payment-success",
        receipt_email: deliveryDetails.email,
        shipping: {
          name: deliveryDetails.fullname,
          phone: `${deliveryDetails.countryCode}${deliveryDetails.phone}`,
          address: {
            line1: deliveryDetails.address,
            line2: deliveryDetails.apartment,
            city: deliveryDetails.city,
            state: deliveryDetails.state,
            postal_code: deliveryDetails.zip,
          },
        },
      },
    });

    setLoading(false);
    if (error) alert(error.message);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      <Button
        type="submit"
        className="btn btn-ibouge w-100 mt-4"
        disabled={!stripe || loading}
      >
        {loading ? "Processing..." : "Confirm & Purchase"}
      </Button>

      <p className="text-muted small text-center mt-3">
        By completing this purchase, you agree to our Terms of Service and Privacy Policy.
      </p>
    </form>
  );
}

export default function CheckoutPage() {
  const cart = useSelector((state) => state.cart);
  const userData = useSelector((state) => state?.auth?.user?.user);
  const [clientSecret, setClientSecret] = useState("");
  const [tax, setTax] = useState(0);
  const [proceed, setProceed] = useState(false);
  const [isAddressValid, setIsAddressValid] = useState(false);
  const shipping = cart.items.reduce((accumulator, currentItem) => { return accumulator + (currentItem.shippingCost*currentItem.quantity)}, 0)
  const [errors, setErrors] = useState({});
  const address = JSON.parse(localStorage.getItem("Address")) || undefined;

  const [deliveryDetails, setDeliveryDetails] = useState({
    fullname: (userData.fname + " " + userData.lname).trim(),
    email: userData.email,
    countryCode: "1",
    phone: address?.phone ? address.phone : '',
    address: address?.address ? address.address : "",
    apartment: address?.apartment ? address.apartment : "",
    city: address?.city ? address.city : "",
    state: address?.state ? address.state : "",
    zip: address?.zip ? address.zip : "",
    country: address?.country ? address.country : "",
  });

  const handleAddressChange = (event) => {
    // 1. Update validity state immediately to toggle UI buttons/loaders
    setIsAddressValid(event.complete);

    if (event.complete) {
      const address = event.value.address;
      
      if (address.country === 'US' && !address.state) {
        setIsAddressValid(false);
        return;
      }

      setDeliveryDetails({
      ...deliveryDetails,
        address: address.line1,
        apartment: address.line2 || "",
        zip: address.postal_code,
        state: address.state,
        country: address.country,
        city: address.city,
        fullname: event.value.name
      });

      console.log(address, 'address element')

    }
  };

  const validateDeliveryDetails = (data) => {
    const errors = {};

    if (!data.fullname.trim()) {
      errors.fullname = "A Full name is required";
    }

    if (!data.phone.trim()) {
      errors.phone = "Phone number required";
    } else if (!/^\d{6,15}$/.test(data.phone)) {
      errors.phone = "Invalid phone number";
    }

    if (!data.address.trim()) {
      errors.address = "Address required";
    }

    if (!data.country.trim()) {
      errors.address = "Country required";
    }

    if (!data.city.trim()) {
      errors.city = "City required";
    }


    return errors;
  };


  const handleSubmit = () => {

    // const err = validateDeliveryDetails(deliveryDetails);

    const err = validateDeliveryDetails(deliveryDetails);

    if (Object.keys(err).length > 0) {
      setErrors(err);
      return;
    }

    setErrors({});

    localStorage.setItem("Address", JSON.stringify(deliveryDetails));

    console.log(deliveryDetails, 'data')

    axios.post(Server2 + "/stripe/getIntent", {
      cartItems: cart.items,
      userId: userData?._id,
      deliveryDetails,
    })
    .then((res) => {
      setTax(parseInt(res.data.tax || 0))
      setClientSecret(res.data.clientSecret)
      setProceed(true);
    }).catch((err) => {
      console.log(err)
      if(err.response.status === 401) {
        console.log(err.response.data)
        setErrors({messageError: err.response.data})
      }
    });

  }

  return (
    <div className="checkout-bg d-flex justify-content-center align-items-center my-5">
      <div
        style={{
          width: "960px",
          background: "#fff",
          borderRadius: "18px",
          padding: "32px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
        }}
      >
      {errors?.messageError &&
        <p className="text-danger text-center mb-3">{errors.messageError}</p>
      }
        <div className="d-flex justify-content-between align-items-center mb-4">
          <img src="/img/Logo.png" alt="iBouge" height={40} />
          <span className="text-muted small">Secure payments by Stripe</span>
        </div>

        <div className="row g-5">
          {/* LEFT: Shipping Information */}
          <div className="col-md-6">
            <h6 className="fw-semibold mb-3">Shipping Information</h6>

            <Elements
              stripe={stripePromise}
              options={{
                appearance: {
                  theme: "stripe",
                  variables: {
                    colorPrimary: "#6f42c1",
                    borderRadius: "8px",
                  },
                },
              }}
            >
              <AddressElement
                options={{ 
                  mode: "billing",
                  defaultValues: address
                  ? {
                      name: address.fullname,
                      address: {
                        line1: address.address,
                        line2: address.apartment,
                        city: address.city,
                        state: address.state,
                        postal_code: address.zip,
                        country: address.country,
                      },
                    }
                  : undefined,
                }}
                onChange={handleAddressChange}
              />
            </Elements>

            {/* Phone Number */}
            <div className="row g-2 mt-2">
              <div className="col-md-3">
                <ReactCountryDropdown
                  defaultCountry="US"
                  onSelect={(country) => setDeliveryDetails({ ...deliveryDetails, countryCode: country.callingCodes[0] })}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.countryCode}
                </Form.Control.Feedback>
              </div>
              <div className="col-md-9">
                <Form.Control
                  placeholder="Phone Number"
                  value={deliveryDetails.phone}
                  onChange={(e) =>
                    setDeliveryDetails({ ...deliveryDetails, phone: e.target.value })
                  }
                  isInvalid={!!errors.phone}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.phone}
                </Form.Control.Feedback>
              </div>
            </div>

            {proceed && <>

              {/* Order Summary (Stripe Loaded) */}
              <h6 className="fw-semibold mb-0 mt-4">Order Summary</h6>
              <div className="border rounded p-3 mb-3">
                {cart.items.map((item, i) => (
                  <div key={i} className="d-flex justify-content-between align-items-center mb-2 small">
                    <span>{item.productName} × {item.quantity}</span>
                    <span>${(item.price * item.quantity).toFixed(2)}</span>
                  </div>
                ))}
                <hr />
                <div className="d-flex justify-content-between fw-semibold">
                  <span>Items ({cart.items.reduce((accumulator, currentItem) => { return accumulator + (currentItem.quantity)}, 0)})</span>
                  <span>${cart.totalAmount.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between fw-semibold mt-2">
                  <span>Shipping & Handling</span>
                  <span>${shipping.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between fw-semibold mt-2">
                  <span>Estimated tax to be collected</span>
                  <span>${tax.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between fw-semibold mt-2">
                  <small>Order Total</small>
                  <small>${(cart.totalAmount + tax + shipping).toFixed(2)}</small>
                </div>
              </div>

            </>}

          </div>

          {/* RIGHT: Order Summary / Stripe */}
          <div className="col-md-6">

            {proceed === false ? 

            <>
              <h6 className="fw-semibold" style={{marginBottom: 14}}>Order Summary</h6>
              <div className="d-flex flex-column justify-content-between h-100" style={{paddingBottom: 40}}>
                <div className="border rounded p-3">
                  {cart.items.map((item, i) => (
                    <div key={i} className="d-flex justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <img
                          src={ item.image ? item.image : "/img/upload-photo.png" }
                          className="avatar avatar-sm me-2 rounded-1"
                          alt="user1"
                        />
                        <div className="d-flex flex-column">
                          <small className="fw-semibold">{item.productName}</small>
                          <span>× {item.quantity}</span>
                        </div>
                      </div>
                      <small className="">${(item.price * item.quantity).toFixed(2)}</small>
                    </div>
                  ))}
                  <hr/>
                  <div className="d-flex justify-content-between mt-2">
                    <div className="d-flex align-items-center gap-1">
                      <small className="fw-semibold">Items
                        ({cart.items.reduce((accumulator, currentItem) => { return accumulator + (currentItem.quantity)}, 0)})
                      </small>
                    </div>
                    <small>${cart.totalAmount.toFixed(2)}</small>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div className="d-flex align-items-center gap-1">
                      <small className="fw-semibold">Shipping & Handling</small>
                    </div>
                    <small>${shipping.toFixed(2)}</small>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div className="d-flex align-items-center gap-1">
                      <small className="fw-semibold">Total</small>
                      <span>(excluding tax)</span>
                    </div>
                    <small>${(cart.totalAmount + tax + shipping).toFixed(2)}</small>
                  </div>
                </div>

                <Button
                  type="submit"
                  className="btn btn-ibouge w-100 mt-1"
                  disabled={!isAddressValid}
                  onClick={()=> handleSubmit()}
                >
                  Continue
                </Button>
              </div>
            </>

            :

            <Elements
              stripe={stripePromise}
              options={{
                clientSecret,
                appearance: {
                  theme: "stripe",
                  variables: {
                    colorPrimary: "#6f42c1",
                    borderRadius: "8px",
                  },
                },
              }}
            >
              <CheckoutForm
                setErrors={setErrors}
                deliveryDetails={deliveryDetails}
                clientSecret={clientSecret}
              />
            </Elements>
            }
          </div>
        </div>
      </div>
    </div>
  );
}